// for WorkareaTreeService

export type DepartmentId = `DepartmentId-${number}`

export type WorkAreaId = `WorkAreaId-${number}`

export type DepartmentOrWorkAreaId = DepartmentId | WorkAreaId

export function isWorkAreaId(v: string): v is WorkAreaId {
  return v.startsWith("WorkAreaId-")
}

export function isDepartmentId(v: string): v is DepartmentId {
  return v.startsWith("DepartmentId-")
}

export function isDepartmentOrWorkaredaId(
  v: string
): v is DepartmentOrWorkAreaId {
  return isDepartmentId(v) || isWorkAreaId(v)
}

export function parseDepartmentId(v: string): number {
  if (!isDepartmentId(v)) throw new Error(`Invalid DepartmentId: ${v}`)
  return parseInt(v.replace("DepartmentId-", ""), 10)
}

export function parseWorkAreaId(v: string): number {
  if (!isWorkAreaId(v)) throw new Error(`Invalid WorkAreaId: ${v}`)
  return parseInt(v.replace("WorkAreaId-", ""), 10)
}
